/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_RecordInputs */

const en_us2_offline_kind_record = /** @type {(inputs: Offline_Kind_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set`)
};

const pt_br2_offline_kind_record = /** @type {(inputs: Offline_Kind_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série`)
};

const es_419_offline_kind_record = /** @type {(inputs: Offline_Kind_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie`)
};

const pt_pt2_offline_kind_record = /** @type {(inputs: Offline_Kind_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série`)
};

const fr_fr2_offline_kind_record = /** @type {(inputs: Offline_Kind_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série`)
};

const de_de2_offline_kind_record = /** @type {(inputs: Offline_Kind_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satz`)
};

const it_it2_offline_kind_record = /** @type {(inputs: Offline_Kind_RecordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie`)
};

/**
* | output |
* | --- |
* | "Set" |
*
* @param {Offline_Kind_RecordInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_record = /** @type {((inputs?: Offline_Kind_RecordInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_RecordInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_record(inputs)
	if (locale === "es-419") return es_419_offline_kind_record(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_record(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_record(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_record(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_record(inputs)
	return en_us2_offline_kind_record(inputs)
});
export { offline_kind_record as "offline.kind_record" }